import { Component } from '@angular/core';
import {ButtonComponent} from "../../ui/button/button.component";
import {FormGroupComponent} from "../../ui/form-group/form-group.component";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {InputComponent} from "../../ui/input/input.component";
import {ModalBodyComponent} from "../../ui/modal-body/modal-body.component";
import {ModalComponent} from "../../ui/modal/modal.component";
import {ModalFooterComponent} from "../../ui/modal-footer/modal-footer.component";
import {ModalTitleComponent} from "../../ui/modal-title/modal-title.component";
import {NgIf} from "@angular/common";
import {TextareaComponent} from "../../ui/textarea/textarea.component";
import {TranslateModule} from "@ngx-translate/core";
import {Tag} from "../../../models/tag";
import {OverlayRef} from "@angular/cdk/overlay";
import {ModalConfig} from "../../../models/modal-config";
import {TagService} from "../../../services/tag.service";
import {Router} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {FileUploadComponent} from "../../ui/file-upload/file-upload.component";

@Component({
  selector: 'app-edit-tag-modal',
  standalone: true,
  imports: [
    ButtonComponent,
    FormGroupComponent,
    FormsModule,
    InputComponent,
    ModalBodyComponent,
    ModalComponent,
    ModalFooterComponent,
    ModalTitleComponent,
    NgIf,
    ReactiveFormsModule,
    TextareaComponent,
    TranslateModule,
    FileUploadComponent
  ],
  templateUrl: './edit-tag-modal.component.html',
  styleUrl: './edit-tag-modal.component.scss'
})
export class EditTagModalComponent {
  public tag?: Tag;
  public form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    color: new FormControl('', [Validators.required]),
    icon: new FormControl(null as string | Blob | null, [Validators.required]),
  });
  public loading = false;
  public error = false;

  loadImage = (url: string) => {
    return firstValueFrom(this.tagService.icon(this.tag!));
  }

  constructor(private overlayRef: OverlayRef, private modalConfig: ModalConfig, private tagService: TagService, private router: Router) {
    this.tag = this.modalConfig?.data?.tag;
    if (this.tag) {
      this.form.patchValue(this.tag);

      if (this.tag.iconFilename) {
        this.form.get('icon')?.patchValue(this.tag.iconFilename);
      }

      // Remove validation for icon if it's already set
      this.form.get('icon')?.clearValidators();
    }
  }

  async save() {
    if (this.loading || !this.form.valid) return;

    this.loading = true;
    this.error = false;

    try {
      const body = { ...this.tag, ...this.form.value } as Tag;
      let result;

      const icon = this.form.get('icon')?.value ?? null;
      if (icon instanceof File) {
        delete (body as any).icon;
      }

      if (this.isEditMode) {
        result = await firstValueFrom(this.tagService.update(body, icon));
        Object.assign(this.tag!, result);
      } else {
        result = await firstValueFrom(this.tagService.create(body, icon));
        this.router.navigate(['panel', 'tags', 'detail', result.id]);
      }

      this.close();
    } catch (e) {
      console.error(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.overlayRef.dispose();
  }

  get isEditMode() {
    return !!this.tag;
  }
}
